import type { ActionType, Player, Role } from "./types";

/**
 * The action each character card unlocks. Contessa (Sentinel) is deliberately
 * absent: it has no action, only a block.
 */
export const ROLE_ACTIONS: Partial<Record<Role, ActionType>> = {
  Regent: "levy",
  Knife: "silence",
  Corsair: "seize",
  Envoy: "exchange"
};

/**
 * Whether `me` is allowed to declare `type` right now, ignoring whose turn it
 * is. Shared by the action dock and the per-card ability chips in the hand so
 * the two can never disagree about what is greyed out.
 */
export function canUseAction(me: Player, type: ActionType): boolean {
  if (me.coins >= 10 && type !== "banish") return false;
  if (type === "banish" && me.coins < 7) return false;
  if (type === "silence" && me.coins < 3) return false;
  return true;
}
